import { gql } from "@apollo/client";

export default gql`
  mutation DeleteProfile($userId: ObjectId!) {
    deleteProfile(userId: $userId)
  }
`;
